export default "__VITE_ASSET__mDMhiBth__";